import { Tooltip } from '@mui/material';

import { styled } from '@mui/material/styles';

const DarkTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    borderRadius: '0.5rem',
    fontSize: 12,
    lineHeight: '1.12rem',
    marginTop: '1rem',
    maxWidth: '10rem',
  },
}));

export default DarkTooltip;
